import React, {useEffect, useState, useRef} from "react";
import css from "./index.module.scss";
import { useInView } from "react-intersection-observer";
import SplitText from "@/components/splitText";
import slideFadeIn from "scripts/animations/slideFadeIn";
import popFadeIn from "scripts/animations/popFadeIn";
import inViewSettings from "scripts/animations/inViewSettings";
import ArrowDownLongSvg from "/public/images/icons/arrowDownLong.svg";
import Card from "@/components/card";

export default function FlowChartSection({
  headline = "More Ways to Grow Your Business",
  subheadline = "Our comprehensive suite of digital marketing services furthers your success.",
  cards = [
    {
      headline: "Step 1: Research",
      body: "We dive into your business goals, target audience, and competitors to inform strategic decisions.",
      icon: <ArrowDownLongSvg/>,
    },
  ],
}) {
  const [elements, setElements] = useState({
    text: useInView(inViewSettings(slideFadeIn)),
    cards: useInView(inViewSettings(popFadeIn)),
  });


  return <section className={`section ${css.approach}`}>
    <div className="sectionInner">
      <div ref={elements.text.ref}>
        <h2>
          <SplitText className="target" text={headline}/>
        </h2>
        <div className={css.subheadline}>
          <SplitText className="target" text={subheadline}/>
        </div>
      </div>
      <div className={css.steps} ref={elements.cards.ref}>
        {cards.map((card, idx) => <>
          <Card light className={`target ${css.card}`} headline={card.headline} icon={card.icon}>
            <div className={css.cardInner}>{card.body}</div>
          </Card>
          {idx < cards.length - 1 && <ArrowDownLongSvg className="target"/>}
        </>)}

      </div>
    </div>
  </section>;
}

